import { baseUrl } from "../../common/config";
import { http } from "../../common/helpers/index";

export const restoreParticipantSocialSecurityIncome = ({
  participantProfileId,
}) => {
  return http.patch(
    `${baseUrl}/api/participant/restore-social-security-income?participantProfileId=${participantProfileId}`
  );
};

export const updatePrimaryEmail = (newPrimaryEmail) =>
  http.post(
    `${baseUrl}/api/auth/participant/update-primary-email-request?newPrimaryEmail=${newPrimaryEmail}`
  );

export const getEvents = (params) => {
  return http.get(`${baseUrl}/api/events`, { params });
};

export const educatorCalendarEvents = (params) =>
  http.get(`${baseUrl}/api/events/educator-calendar`, { params });

export const saveEvent = ({ eventDetails }) =>
  http.post(`${baseUrl}/api/events/participant`, eventDetails);

export const updateEvent = ({ eventDetails }) =>
  http.put(`${baseUrl}/api/events`, eventDetails);

export const cancelEvent = ({ eventId }) =>
  http.post(`${baseUrl}/api/events/${eventId}/cancel`);

export const confirmEvent = ({ eventId }) =>
  http.post(`${baseUrl}/api/events/${eventId}/confirm`);

export const getUpcomingEvents = () => {
  return http.get(`${baseUrl}/api/events/upcoming/mine`);
};

export const getEventDetails = ({ eventId }) =>
  http.get(`${baseUrl}/api/events/${eventId}`);

export const getWorkingHours = ({ educatorId }) =>
  http.get(
    `${baseUrl}/api/events/working-hours?educatorProfileId=${educatorId}`
  );

export const getParticipantFAQ = (organizationId) =>
  http.get(`${baseUrl}/api/organization/${organizationId}/faq`);

export const getGlossaryService = (params) =>
  http.get(`${baseUrl}/api/glossaries/get-all`, { params });
